import axios from 'axios'

const service = axios.create({
  baseURL: process.env.VUE_APP_SITE,
  timeout: 50000
})

service.interceptors.request.use(
  request => {
    return request
  },
  error => {
    return Promise.reject(error)
  }
)

export default service
